interface Dictionary<T> {
  [Key: string]: T;
}

export interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  submenuicon?: string;
  //submenuicon2?: string;
  class: string;
  children?: Array<Dictionary<string>>;
}

export const ROUTES_SystemAdministratorConfig: RouteInfo[] = [
  {
    path: '/service-request/search',
    title: 'Service Requests',
    icon: '../../../../assets/img/icons/new_icons/Mask Group 7.svg',
    class: 'primary-color-red',
  }, //icon-pending.svg', class: 'primary-color-red'},

  {
    path: '/cbm/search',
    title: 'CBM Management',
    icon: '../../../../assets/img/icons/new_icons/Mask Group 8.svg',
    class: 'primary-color-white',
  }, //icon-hardhat.svg', class: 'primary-color-gray' },
  {
    path: '/user',
    title: 'user management',
    icon: '../../../../assets/img/icons/new_icons/Mask Group 9.svg',
    submenuicon:
      '../../../../assets/img/icons/SidenavArrows/SVG/Sidenav_Default.svg',
    class: 'primary-color-white',
    children: [
      //icon-users.svg', submenuicon: '../../../../assets/img/icons/icon', class: 'primary-color-white', children: [
      {
        path: '/user/searchProfiles',
        title: 'user profiles',
        icon: '',
        class: 'primary-color-white',
      },
      {
        path: '/user/search',
        title: 'user records',
        icon: '',
        class: 'primary-color-white',
      },
    ],
  },
  //{ path: '/reports-mgmt', title: 'Overall Report', icon: '../../../../assets/img/icons/new_icons/Mask Group 10.svg', class: 'primary-color-white'}, //icon-pending.svg', class: 'primary-color-white'},
  {
    path: '',
    title: 'Overall Report',
    icon: '../../../../assets/img/reports_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '/config-settings',
    title: 'Configure Settings',
    icon: '../../../../assets/img/icons/new_icons/Mask Group 11.svg',
    submenuicon:
      '../../../../assets/img/icons/SidenavArrows/SVG/Sidenav_Default.svg',
    class: 'primary-color-white',
    children: [
      {
        path: '/config-settings/search-status-tagging',
        title: 'status tagging',
        icon: '',
        class: 'primary-color-white',
      },
      {
        path: '/config-settings/view-suspension-delisting',
        title: 'suspension & delisting',
        icon: '',
        class: 'primary-color-white',
      },
      {
        path: '/config-settings/view-recommendation-logic',
        title: 'recommendation logic',
        icon: '',
        class: 'primary-color-white',
      },
    ],
  }, //, //icon-pending.svg', class: 'primary-color-white'}
  //{ path: '/change-pass', title: 'Change Password', icon: '../../../../assets/img/resetPass_default.svg', class: 'primary-color-white'}
];

export var ROUTES_FrontlinerConfiguredNoReport: RouteInfo[] = [
  {
    path: '/service-request/create',
    title: 'Create Service Request',
    icon:
      '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/SR_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '/service-request/search',
    title: 'Pending Transactions',
    icon:
      '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/transaction_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '',
    title: 'Overall Report',
    icon: '../../../../assets/img/reports_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '/service-request/transaction-history',
    title: 'Transaction History',
    icon:
      '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/history_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '/cbm-rating/cbm-rating-search',
    title: 'CBM Technical Rating',
    icon:
      '../../../../assets/img/CBM tech rating icons/tech_rating_default copy.svg',
    class: 'primary-color-red',
  }, //icon-pending.svg', class: 'primary-color-red'},
];

export var ROUTES_FrontlinerConfiguredNoReportNoRating: RouteInfo[] = [
  {
    path: '/service-request/create',
    title: 'Create Service Request',
    icon:
      '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/SR_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '/service-request/search',
    title: 'Pending Transactions',
    icon:
      '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/transaction_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '',
    title: 'Overall Report',
    icon: '../../../../assets/img/reports_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '/service-request/transaction-history',
    title: 'Transaction History',
    icon:
      '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/history_default.svg',
    class: 'primary-color-white',
  },
  //{ path: '/cbm-rating/cbm-rating-search', title: 'CBM Technical Rating', icon: '../../../../assets/img/CBM tech rating icons/tech_rating_default copy.svg', class: 'primary-color-red'}, //icon-pending.svg', class: 'primary-color-red'},
];

export var ROUTES_FrontlinerConfiguredNoCSR: RouteInfo[] = [
  {
    path: '',
    title: 'Create Service Request',
    icon:
      '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/SR_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '/service-request/search',
    title: 'Pending Transactions',
    icon:
      '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/transaction_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '/reports',
    title: 'Overall Report',
    icon: '../../../../assets/img/reports_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '/service-request/transaction-history',
    title: 'Transaction History',
    icon:
      '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/history_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '/cbm-rating/cbm-rating-search',
    title: 'CBM Technical Rating',
    icon:
      '../../../../assets/img/CBM tech rating icons/tech_rating_default copy.svg',
    class: 'primary-color-red',
  }, //icon-pending.svg', class: 'primary-color-red'},
];

export var ROUTES_FrontlinerConfiguredNoCSRNoRating: RouteInfo[] = [
  {
    path: '',
    title: 'Create Service Request',
    icon:
      '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/SR_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '/service-request/search',
    title: 'Pending Transactions',
    icon:
      '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/transaction_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '/reports',
    title: 'Overall Report',
    icon: '../../../../assets/img/reports_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '/service-request/transaction-history',
    title: 'Transaction History',
    icon:
      '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/history_default.svg',
    class: 'primary-color-white',
  },
  //{ path: '/cbm-rating/cbm-rating-search', title: 'CBM Technical Rating', icon: '../../../../assets/img/CBM tech rating icons/tech_rating_default copy.svg', class: 'primary-color-red'}, //icon-pending.svg', class: 'primary-color-red'},
];

export var ROUTES_SystemAdministratorConfigAndCBMRating: RouteInfo[] = [
  {
    path: '/service-request/search',
    title: 'Service Requests',
    icon: '../../../../assets/img/icons/new_icons/Mask Group 7.svg',
    class: 'primary-color-red',
  }, //icon-pending.svg', class: 'primary-color-red'},
  {
    path: '/cbm-rating/cbm-rating-search',
    title: 'CBM Technical Rating',
    icon:
      '../../../../assets/img/CBM tech rating icons/tech_rating_default copy.svg',
    class: 'primary-color-red',
  }, //icon-pending.svg', class: 'primary-color-red'},

  {
    path: '/cbm/search',
    title: 'CBM Management',
    icon: '../../../../assets/img/icons/new_icons/Mask Group 8.svg',
    class: 'primary-color-white',
  }, //icon-hardhat.svg', class: 'primary-color-gray' },
  {
    path: '/user',
    title: 'user management',
    icon: '../../../../assets/img/icons/new_icons/Mask Group 9.svg',
    submenuicon:
      '../../../../assets/img/icons/SidenavArrows/SVG/Sidenav_Default.svg',
    class: 'primary-color-white',
    children: [
      //icon-users.svg', submenuicon: '../../../../assets/img/icons/icon', class: 'primary-color-white', children: [
      {
        path: '/user/searchProfiles',
        title: 'user profiles',
        icon: '',
        class: 'primary-color-white',
      },
      {
        path: '/user/search',
        title: 'user records',
        icon: '',
        class: 'primary-color-white',
      },
    ],
  },
  //{ path: '/reports-mgmt', title: 'Overall Report', icon: '../../../../assets/img/icons/new_icons/Mask Group 10.svg', class: 'primary-color-white'}, //icon-pending.svg', class: 'primary-color-white'},
  {
    path: '',
    title: 'Overall Report',
    icon: '../../../../assets/img/reports_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '/config-settings',
    title: 'Configure Settings',
    icon: '../../../../assets/img/icons/new_icons/Mask Group 11.svg',
    submenuicon:
      '../../../../assets/img/icons/SidenavArrows/SVG/Sidenav_Default.svg',
    class: 'primary-color-white',
    children: [
      {
        path: '/config-settings/search-status-tagging',
        title: 'status tagging',
        icon: '',
        class: 'primary-color-white',
      },
      {
        path: '/config-settings/view-suspension-delisting',
        title: 'suspension & delisting',
        icon: '',
        class: 'primary-color-white',
      },
      {
        path: '/config-settings/view-recommendation-logic',
        title: 'recommendation logic',
        icon: '',
        class: 'primary-color-white',
      },
    ],
  },
];

export var ROUTES_FrontlinerConfiguredNoBothCSRandReport: RouteInfo[] = [
  {
    path: '',
    title: 'Create Service Request',
    icon:
      '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/SR_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '/service-request/search',
    title: 'Pending Transactions',
    icon:
      '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/transaction_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '',
    title: 'Overall Report',
    icon: '../../../../assets/img/reports_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '/service-request/transaction-history',
    title: 'Transaction History',
    icon:
      '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/history_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '/cbm-rating/cbm-rating-search',
    title: 'CBM Technical Rating',
    icon:
      '../../../../assets/img/CBM tech rating icons/tech_rating_default copy.svg',
    class: 'primary-color-red',
  }, //icon-pending.svg', class: 'primary-color-red'},
];

export var ROUTES_FrontlinerConfiguredNoBothCSRandReportNoRating: RouteInfo[] = [
  {
    path: '',
    title: 'Create Service Request',
    icon:
      '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/SR_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '/service-request/search',
    title: 'Pending Transactions',
    icon:
      '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/transaction_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '',
    title: 'Overall Report',
    icon: '../../../../assets/img/reports_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '/service-request/transaction-history',
    title: 'Transaction History',
    icon:
      '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/history_default.svg',
    class: 'primary-color-white',
  },
  //{ path: '/cbm-rating/cbm-rating-search', title: 'CBM Technical Rating', icon: '../../../../assets/img/CBM tech rating icons/tech_rating_default copy.svg', class: 'primary-color-red'}, //icon-pending.svg', class: 'primary-color-red'},
];

export const ROUTES_FrontlinerNormalCBMRating: RouteInfo[] = [
  {
    path: '/service-request/create',
    title: 'Create Service Request',
    icon:
      '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/SR_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '/service-request/search',
    title: 'Pending Transactions',
    icon:
      '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/transaction_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '/reports',
    title: 'Overall Report',
    icon: '../../../../assets/img/reports_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '/service-request/transaction-history',
    title: 'Transaction History',
    icon:
      '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/history_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '/cbm-rating/cbm-rating-search',
    title: 'CBM Technical Rating',
    icon:
      '../../../../assets/img/CBM tech rating icons/tech_rating_default copy.svg',
    class: 'primary-color-red',
  }, //icon-pending.svg', class: 'primary-color-red'},

  //{ path: '/change-pass/change-pass', title: 'Change Password', icon: '../../../../assets/img/resetPass_default.svg', class: 'primary-color-white'}
  // { path: '/service-request/transaction-history', title: 'Transaction History', icon: '../../../../assets/img/icons/icon-folder.svg', class: 'primary-color-white'},
  // { path: '/report', title: 'Report', icon:'nc-time-alarm', class: 'primary-color-white'}
];

export const ROUTES_Frontliner: RouteInfo[] = [
  {
    path: '/service-request/create',
    title: 'Create Service Request',
    icon:
      '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/SR_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '/service-request/search',
    title: 'Pending Transactions',
    icon:
      '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/transaction_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '/reports',
    title: 'Overall Report',
    icon: '../../../../assets/img/reports_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '/service-request/transaction-history',
    title: 'Transaction History',
    icon:
      '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/history_default.svg',
    class: 'primary-color-white',
  },
  //{ path: '/cbm-rating/cbm-rating-search', title: 'CBM Technical Rating', icon: '../../../../assets/img/CBM tech rating icons/tech_rating_default copy.svg', class: 'primary-color-red'}, //icon-pending.svg', class: 'primary-color-red'},

  //{ path: '/change-pass/change-pass', title: 'Change Password', icon: '../../../../assets/img/resetPass_default.svg', class: 'primary-color-white'}
  // { path: '/service-request/transaction-history', title: 'Transaction History', icon: '../../../../assets/img/icons/icon-folder.svg', class: 'primary-color-white'},
  // { path: '/report', title: 'Report', icon:'nc-time-alarm', class: 'primary-color-white'}
];

export const ROUTES_FrontlinerCBMRating: RouteInfo[] = [
  {
    path: '/service-request/create',
    title: 'Create Service Request',
    icon:
      '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/SR_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '/service-request/search',
    title: 'Pending Transactions',
    icon:
      '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/transaction_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '/reports',
    title: 'Overall Report',
    icon: '../../../../assets/img/reports_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '/service-request/transaction-history',
    title: 'Transaction History',
    icon:
      '../../../../assets/img/Frontliner Sidenav Icons/Frontliner Sidenav Icons/history_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '/cbm-rating/cbm-rating-search',
    title: 'CBM Technical Rating',
    icon:
      '../../../../assets/img/CBM tech rating icons/tech_rating_default copy.svg',
    class: 'primary-color-red',
  }, //icon-pending.svg', class: 'primary-color-red'},

  //{ path: '/change-pass/change-pass', title: 'Change Password', icon: '../../../../assets/img/resetPass_default.svg', class: 'primary-color-white'}
  // { path: '/service-request/transaction-history', title: 'Transaction History', icon: '../../../../assets/img/icons/icon-folder.svg', class: 'primary-color-white'},
  // { path: '/report', title: 'Report', icon:'nc-time-alarm', class: 'primary-color-white'}
];

export const ROUTES_SystemAdministratorCBMRating: RouteInfo[] = [
  {
    path: '/service-request/search',
    title: 'Service Requests',
    icon: '../../../../assets/img/icons/new_icons/Mask Group 7.svg',
    class: 'primary-color-red',
  }, //icon-pending.svg', class: 'primary-color-red'},
  {
    path: '/cbm-rating/cbm-rating-search',
    title: 'CBM Technical Rating',
    icon:
      '../../../../assets/img/CBM tech rating icons/tech_rating_default copy.svg',
    class: 'primary-color-red',
  }, //icon-pending.svg', class: 'primary-color-red'},

  {
    path: '/cbm/search',
    title: 'CBM Management',
    icon: '../../../../assets/img/icons/new_icons/Mask Group 8.svg',
    class: 'primary-color-white',
  }, //icon-hardhat.svg', class: 'primary-color-gray' },
  {
    path: '/user',
    title: 'user management',
    icon: '../../../../assets/img/icons/new_icons/Mask Group 9.svg',
    submenuicon:
      '../../../../assets/img/icons/SidenavArrows/SVG/Sidenav_Default.svg',
    class: 'primary-color-white',
    children: [
      //icon-users.svg', submenuicon: '../../../../assets/img/icons/icon', class: 'primary-color-white', children: [
      {
        path: '/user/searchProfiles',
        title: 'user profiles',
        icon: '',
        class: 'primary-color-white',
      },
      {
        path: '/user/search',
        title: 'user records',
        icon: '',
        class: 'primary-color-white',
      },
    ],
  },
  //{ path: '/reports-mgmt', title: 'Overall Report', icon: '../../../../assets/img/icons/new_icons/Mask Group 10.svg', class: 'primary-color-white'}, //icon-pending.svg', class: 'primary-color-white'},
  {
    path: '/reports',
    title: 'Overall Report',
    icon: '../../../../assets/img/reports_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '/config-settings',
    title: 'Configure Settings',
    icon: '../../../../assets/img/icons/new_icons/Mask Group 11.svg',
    submenuicon:
      '../../../../assets/img/icons/SidenavArrows/SVG/Sidenav_Default.svg',
    class: 'primary-color-white',
    children: [
      {
        path: '/config-settings/search-status-tagging',
        title: 'status tagging',
        icon: '',
        class: 'primary-color-white',
      },
      {
        path: '/config-settings/view-suspension-delisting',
        title: 'suspension & delisting',
        icon: '',
        class: 'primary-color-white',
      },
      {
        path: '/config-settings/view-recommendation-logic',
        title: 'recommendation logic',
        icon: '',
        class: 'primary-color-white',
      },
    ],
  }, //,
  //{ path: '/change-pass', title: 'Change Password', icon: '../../../../assets/img/resetPass_default.svg', class: 'primary-color-white'}
];

export const ROUTES_SystemAdministrator: RouteInfo[] = [
  //FOR FRONTLINER
  /*{ path: '/service-request/search', title: 'Service Requests', icon: '../../../../assets/img/icons/new_icons/Mask Group 7.svg', class: 'primary-color-red'}, //icon-pending.svg', class: 'primary-color-red'},

    { path: '/cbm/search', title: 'CBM Management', icon: '../../../../assets/img/icons/new_icons/Mask Group 8.svg', class: 'primary-color-white'}, //icon-hardhat.svg', class: 'primary-color-gray' },
    { path: '/user', title: 'user management', icon: '../../../../assets/img/icons/new_icons/Mask Group 9.svg', submenuicon: '../../../../assets/img/icons/SidenavArrows/SVG/Sidenav_Default.svg', class: 'primary-color-white' , children: [ //icon-users.svg', submenuicon: '../../../../assets/img/icons/icon', class: 'primary-color-white', children: [
        { path: '/user/searchProfiles', title: 'user profiles',  icon: '', class: 'primary-color-white' },
        { path: '/user/search', title: 'user records',  icon: '', class: 'primary-color-white' }
    ]
    },
    { path: '/reports-mgmt', title: 'Overall Report', icon: '../../../../assets/img/icons/new_icons/Mask Group 10.svg', class: 'primary-color-white'}, //icon-pending.svg', class: 'primary-color-white'},
    { path: '/config-settings', title: 'Configure Settings', icon: '../../../../assets/img/icons/new_icons/Mask Group 11.svg', submenuicon: '../../../../assets/img/icons/SidenavArrows/SVG/Sidenav_Default.svg', class: 'primary-color-white', children: [
        { path: '', title: 'status tagging', icon: '', class: 'primary-color-white' },
        { path: '', title: 'suspension & delisting', 'icon': '', class: 'primary-color-white'},
        { path: '', title: 'recommendation logic', 'icon': '', class: 'primary-color-white'}
    ]}*/ //icon-pending.svg', class: 'primary-color-white'}

  //FOR ADMIN
  {
    path: '/service-request/search',
    title: 'Service Requests',
    icon: '../../../../assets/img/icons/new_icons/Mask Group 7.svg',
    class: 'primary-color-red',
  }, //icon-pending.svg', class: 'primary-color-red'},

  {
    path: '/cbm/search',
    title: 'CBM Management',
    icon: '../../../../assets/img/icons/new_icons/Mask Group 8.svg',
    class: 'primary-color-white',
  }, //icon-hardhat.svg', class: 'primary-color-gray' },
  {
    path: '/user',
    title: 'user management',
    icon: '../../../../assets/img/icons/new_icons/Mask Group 9.svg',
    submenuicon:
      '../../../../assets/img/icons/SidenavArrows/SVG/Sidenav_Default.svg',
    class: 'primary-color-white',
    children: [
      //icon-users.svg', submenuicon: '../../../../assets/img/icons/icon', class: 'primary-color-white', children: [
      {
        path: '/user/searchProfiles',
        title: 'user profiles',
        icon: '',
        class: 'primary-color-white',
      },
      {
        path: '/user/search',
        title: 'user records',
        icon: '',
        class: 'primary-color-white',
      },
    ],
  },
  //{ path: '/reports-mgmt', title: 'Overall Report', icon: '../../../../assets/img/icons/new_icons/Mask Group 10.svg', class: 'primary-color-white'}, //icon-pending.svg', class: 'primary-color-white'},
  {
    path: '/reports',
    title: 'Overall Report',
    icon: '../../../../assets/img/reports_default.svg',
    class: 'primary-color-white',
  },
  {
    path: '/config-settings',
    title: 'Configure Settings',
    icon: '../../../../assets/img/icons/new_icons/Mask Group 11.svg',
    submenuicon:
      '../../../../assets/img/icons/SidenavArrows/SVG/Sidenav_Default.svg',
    class: 'primary-color-white',
    children: [
      {
        path: '/config-settings/search-status-tagging',
        title: 'status tagging',
        icon: '',
        class: 'primary-color-white',
      },
      {
        path: '/config-settings/view-suspension-delisting',
        title: 'suspension & delisting',
        icon: '',
        class: 'primary-color-white',
      },
      {
        path: '/config-settings/view-recommendation-logic',
        title: 'recommendation logic',
        icon: '',
        class: 'primary-color-white',
      },
    ],
  }, //, //icon-pending.svg', class: 'primary-color-white'}
  //{ path: '/change-pass', title: 'Change Password', icon: '../../../../assets/img/resetPass_default.svg', class: 'primary-color-white'}
];
